import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_LOYALTY](state, payload) {
    state.loyalty = payload;
  },
  [MutationsType.SET_LOYALTY_CLIENT](state, payload) {
    state.loyaltyClient = payload;
  },
  [MutationsType.SET_LOYALTY_CLIENT_TRANSACTIONS](state, payload) {
    state.loyaltyClientTransactions = payload;
  },
  [MutationsType.SET_LOYALTY_SEGMENTATION_CONFIG](state, payload) {
    state.loyaltySegmentationConfig = payload;
  },
  [MutationsType.SET_LOYALTY_SEGMENTATION](state, payload) {
    state.loyaltySegmentation = payload;
  },
};
